import { Store, type iNotification } from 'react-notifications-component';
import i18next from '../i18n';

// for options see: https://github.com/teodosii/react-notifications-component
// demo: https://teodosii.github.io/react-notifications-component/
// animation classes: https://animate.style/
const notify = (
  title: string,
  message: string,
  options: Partial<iNotification> = {},
): void => {
  Store.addNotification({
    title: i18next.t(title),
    message: i18next.t(message),
    type: 'success', // success | danger | info | default | warning
    container: 'top-right',
    animationOut: ['animate__animated', 'animate__zoomOut'],
    dismiss: {
      duration: 3000,
      onScreen: true,
      pauseOnHover: true,
      waitForAnimation: true,
    },
    ...options,
  });
};

export default notify;
